import { useState } from 'react'
import '../styles/components/invitation-card.css'

function InvitationCard({ senderName = "Nogen", topics = [], onAccept }) {
  const [showDeclineConfirm, setShowDeclineConfirm] = useState(false)
  const [showConfetti, setShowConfetti] = useState(false)

  const handleDecline = () => {
    setShowDeclineConfirm(true)
  }

  const handleDeclineConfirm = () => {
    handleMaybeClick()
  }

  const handleMaybeClick = () => {
    onAccept('maybe')
  }

  const handleYesClick = () => {
    setShowConfetti(true)
    setTimeout(() => {
      onAccept('yes')
    }, 1500)
  }

  if (showDeclineConfirm) {
    return (
      <div className="invitation-card decline-confirm">
        <div className="invitation-content">
          <div className="invitation-icon">💙</div>
          <h2 className="invitation-title">Er du sikker?</h2>
          <p className="invitation-message">
            Jeres forhold fortjener ærlige svar.
            <br />
            Det tager kun 2-3 minutter.
          </p>
          <div className="invitation-actions">
            <button 
              className="btn btn-outline"
              onClick={() => setShowDeclineConfirm(false)}
            >
              Tilbage
            </button>
            <button 
              className="btn btn-primary"
              onClick={handleDeclineConfirm}
            >
              OK, lad os prøve →
            </button>
          </div>
        </div>
      </div>
    )
  }

  return (
    <div className="invitation-card">
      {showConfetti && (
        <div className="confetti-container">
          {[...Array(50)].map((_, i) => (
            <div
              key={i}
              className="confetti"
              style={{
                left: `${Math.random() * 100}%`,
                animationDelay: `${Math.random() * 0.5}s`,
                backgroundColor: ['#667eea', '#764ba2', '#f093fb', '#4facfe'][Math.floor(Math.random() * 4)]
              }}
            />
          ))}
        </div>
      )}
      
      <div className="invitation-content">
        <div className="invitation-icon">🎴</div>
        <h2 className="invitation-title">Du er inviteret!</h2>
        <p className="invitation-message">
          <strong>{senderName}</strong> vil gerne have dine ærlige svar på:
        </p>
        
        <div className="invitation-topics">
          {topics.slice(0, 3).map((topic, index) => (
            <div key={index} className="topic-badge">
              {topic.topicName || topic.text?.substring(0, 30) + '...' || 'Emne'}
            </div>
          ))}
          {topics.length > 3 && (
            <div className="topic-badge more">
              +{topics.length - 3} mere
            </div>
          )}
        </div>

        <p className="invitation-question">Vil du acceptere?</p>

        <div className="invitation-actions">
          <button 
            className="btn btn-decline"
            onClick={handleDecline}
          >
            Nej
          </button>
          <button 
            className="btn btn-maybe"
            onClick={handleMaybeClick}
          >
            Måske
          </button>
          <button 
            className="btn btn-accept"
            onClick={handleYesClick}
          >
            Ja! 🎉
          </button>
        </div>

        <p className="invitation-note">
          💡 Det tager kun 2-3 minutter
        </p>
      </div>
    </div>
  )
}

export default InvitationCard
